// extracted by mini-css-extract-plugin
export default {"shortcut":"KeyboardShortcutsModalContent-shortcut-nblFz","key":"KeyboardShortcutsModalContent-key-zJf3y"};